import type { VisibilityCondition } from '@packages/table-builder/core/schema/types';

/**
 * Legacy `psu-awards/index.tsx` filteredData (lines 871–875):
 * items.filter(
 *   (item) =>
 *     (item?.isDownloadable || item?.isAccepted || item?.status === 'Approved') &&
 *     item?.isEmailNotificationSent === false
 * )
 */
export function isPsuAwardBulkSelectable(row: Record<string, unknown>): boolean {
  return (
    (Boolean(row.isDownloadable) || Boolean(row.isAccepted) || row.status === 'Approved') &&
    row.isEmailNotificationSent === false
  );
}

/** V2 schema `selection.selectable` — mirrors {@link isPsuAwardBulkSelectable}. */
export const psuAwardBulkRowSelectable: VisibilityCondition = {
  logic: 'AND',
  conditions: [
    {
      logic: 'OR',
      conditions: [
        { field: 'isDownloadable', operator: 'TRUTHY' },
        { field: 'isAccepted', operator: 'TRUTHY' },
        { field: 'status', operator: 'EQUAL', value: 'Approved' },
      ],
    },
    { field: 'isEmailNotificationSent', operator: 'EQUAL', value: false },
  ],
};
